import { Button } from "@mui/material";
import { PlanId } from "components/common/boundary/PlanId";
import { useTenantTranslation } from "hooks/formatters";
import { deployPlanFormSlice } from "src/store/slices/deployPlanFormSlice";
import { useAppDispatch } from "src/store/store";

interface Props {
  planId: PlanId;
  doClose: () => void;
}

export const CancelButton = ({ planId, doClose }: Props) => {
  const { t } = useTenantTranslation();
  const dispatch = useAppDispatch();
  const handleOnClick = () => {
    doClose();
    dispatch(deployPlanFormSlice.actions.cancelFlow(planId));
  };
  return (
    <Button variant="outlined" onClick={handleOnClick}>
      {t("cancel")}
    </Button>
  );
};
